<template>
  <div class="liu">
    <mt-header fixed :title="title" class="title2 border-b">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="content" v-if="agentDetail.name">
      <!-- 代理商基本信息 -->
      <div class="agent-info detail">
        <img :src="agentDetail.logoUrl || require('../assets/image_default_agent@3x.png')" width="44" height="44" />
        <span class="agent-name">{{ agentDetail.name }}</span>
        <span class="agent-star">{{ agentDetail.level }}</span>
        <span class="agent-tel" @click="onUserMobileClick">{{ getUserDetailMoblie(agentDetail.mobile) }}</span>
      </div>
      <!-- 费率 -->
      <div class="agent-fee-box" v-if="agentDetail.rate && agentDetail.rate.length">
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <div class="agent-detail-title bb0">
                <div>
                  <span slot="icon" class="blue_line"></span>
                  <span>费率</span>
                </div>
              </div>
            </template>
            <div class="agent-fee" :class="setRateClass(item.name, item.value)" v-for="(item, index) in rateAllData" :key="index">
              <div class="fee-info-box" :class="multRateClass(item.value)">
                <div>
                  <span>{{ formatRateName(item.name) }}</span>
                </div>
                <div v-show="item.isFromRateAudit">
                  <span class="type-word">{{ item.auditTypeChs }}</span>
                </div>
              </div>
              <div class="fee-info-box" :class="multRateClass(item.value)">
                <div>
                  <span v-html="formatRateValue(item.value)" />
                </div>
                <div class="fee-fail" v-if="item.isAuditRate == 1 && item.auditType == 2">
                  <div>
                    <span>{{ item.auditContent }}</span>
                  </div>
                  <div v-show="item.auditTypeLink">
                    <span class="link-btn" @click="onAuditLinkClick(item.busChannelId)">
                      {{ item.auditTypeLink }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 代理数/商户数 -->
      <div class="agent-push-box" v-if="isShowOfZt">
        <div class="agent-push center">
          <span class="fee-info-box">直推代理数(人)</span>
          <span class="fee-info-box">{{ agentDetail.agentCount }}</span>
        </div>
        <div class="agent-push center">
          <span class="fee-info-box">直推商户数(人)</span>
          <span class="fee-info-box">{{ agentDetail.userCount }}</span>
        </div>
      </div>
      <!-- 2020.11.19添加 终端数 -->
      <div class="agent-info-box" v-if="isShowOfZd">
        <div class="agent-info detail title">
          <span class="title-text" :class="getAgentNameClass()">{{ agentDetail.deviceCount[0].title }}</span>
          <span class="title-count">{{ agentDetail.deviceCount[0].allCount }}</span>
        </div>
        <div class="agent-detail">
          <div class="item-cell">
            <div class="cell-top-b">{{ agentDetail.deviceCount[0].baseList[0].value }}</div>
            <div class="cell-bottom">{{ agentDetail.deviceCount[0].baseList[0].name }}</div>
          </div>
        </div>
        <div class="agent-detail">
          <div class="item-cell">
            <div class="cell-top-b">{{ agentDetail.deviceCount[0].baseList[1].value }}</div>
            <div class="cell-bottom">{{ agentDetail.deviceCount[0].baseList[1].name }}</div>
          </div>
        </div>
      </div>
      <!-- 2020.11.19 添加 标签数 -->
      <!-- 2021.09.02 修改为 实体标签数 -->
      <div class="agent-info-box" v-if="isShowOfStbq">
        <div class="agent-info detail title">
          <span class="title-text" :class="getAgentNameClass()">{{ agentDetail.deviceCount[1].title }}</span>
          <span class="title-count">{{ agentDetail.deviceCount[1].allCount }}</span>
        </div>
        <div class="agent-label-detail">
          <div class="item-title">
            {{ agentDetail.deviceCount[1].baseList[0].subtitle }}
          </div>
          <div class="item-cell">
            <div class="cell-top-b">{{ agentDetail.deviceCount[1].baseList[0].value }}</div>
            <div class="cell-bottom">{{ agentDetail.deviceCount[1].baseList[0].name }}</div>
          </div>
        </div>
        <div class="agent-label-detail">
          <div class="item-title">
            {{ agentDetail.deviceCount[1].baseList[1].subtitle }}
          </div>
          <div class="item-cell">
            <div class="cell-top-b">{{ agentDetail.deviceCount[1].baseList[1].value }}</div>
            <div class="cell-bottom">{{ agentDetail.deviceCount[1].baseList[1].name }}</div>
          </div>
        </div>
      </div>
      <!-- 2021.09.02 添加 电子标签数 -->
      <div class="agent-info-box" v-if="isShowOfDzbq">
        <div class="agent-info detail title">
          <span class="title-text" :class="getAgentNameClass()">{{ agentDetail.deviceCount[2].title }}</span>
          <span class="title-count">{{ agentDetail.deviceCount[2].allCount }}</span>
        </div>
        <div class="agent-label-detail">
          <div class="item-title">
            {{ agentDetail.deviceCount[2].baseList[0].subtitle }}
          </div>
          <div class="item-cell">
            <div class="cell-top-b">{{ agentDetail.deviceCount[2].baseList[0].value }}</div>
            <div class="cell-bottom">{{ agentDetail.deviceCount[2].baseList[0].name }}</div>
          </div>
        </div>
        <div class="agent-label-detail">
          <div class="item-title">
            {{ agentDetail.deviceCount[2].baseList[1].subtitle }}
          </div>
          <div class="item-cell">
            <div class="cell-top-b">{{ agentDetail.deviceCount[2].baseList[1].value }}</div>
            <div class="cell-bottom">{{ agentDetail.deviceCount[2].baseList[1].name }}</div>
          </div>
        </div>
      </div>
      <!-- 本月业绩 -->
      <div class="agent-detail-box" v-if="agentDetail.reward && agentDetail.reward.length">
        <div class="agent-detail-title">
          <div>
            <span slot="icon" class="blue_line"></span>
            <span>本月业绩</span>
          </div>
          <div @click="onEyeClick">
            <svg-icon :icon-class="imgEyePath" class-name="cur-icon"></svg-icon>
          </div>
        </div>
        <div class="agent-detail" v-for="(itemA, indexA) in agentDetail.reward" :key="indexA">
          <div class="item-cell">
            <div class="cell-top-b">{{ itemA.date }}</div>
            <div class="cell-bottom">{{ itemA.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT,PUBLIC_SYSTEM_FLAG */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetAgentDetailsForH5 } from '@/api/agent';
import { AuditSysRateFailNoShow } from '@/api/sysRate';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
export default {
  name: 'AgentDetail',
  data() {
    return {
      title: '代理商详情',
      imgEyePath: 'hide_money',
      telStatus: false, // 拨打手机号状态
      product: PUBLIC_PRODUCT,
      agentDetail: {
        logoUrl: '',
        name: '',
        level: '',
        mobile: '',
        rate: [],
        push: [],
        reward: [],
        equipmentCount: [],
        deviceCount: [],
      },
      rateAllData: [],
      realRewardData: [],
      starRewardData: [],
      userMobileShowStar: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.INTERFACE_ON_OFF === 'on') {
        this.getAgentDetails(this.$route.query.productAgentId);
      } else {
        this.fillFalseData();
      }
    });
  },
  computed: {
    // 是否显示直推
    isShowOfZt() {
      return this.product === 'cxpluszs';
    },
    // 是否显示终端数
    isShowOfZd() {
      return this.agentDetail.deviceCount && this.agentDetail.deviceCount.length && this.agentDetail.deviceCount[0];
    },
    // 是否显示实体标签数
    isShowOfStbq() {
      return this.agentDetail.deviceCount && this.agentDetail.deviceCount.length && this.agentDetail.deviceCount[1];
    },
    // 是否显示电子标签数
    isShowOfDzbq() {
      return this.agentDetail.deviceCount && this.agentDetail.deviceCount.length && this.agentDetail.deviceCount[2];
    },
  },
  methods: {
    // 获取代理商详情
    getAgentDetails(productAgentId) {
      Indicator.open();
      GetAgentDetailsForH5({ productAgentId })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.agentDetail = res.data;
            // 2020.12.3 新加审核中费率的处理
            // 1.给“审核中费率"添加标识文字和新的样式
            res.data.rateAudit.forEach(i => {
              i.isFromRateAudit = true;
              i.auditTypeChs = i.auditType === 2 ? '(审核失败)' : '(审核中)';
              i.auditTypeLink = i.auditType === 2 ? '知道了' : '';
            });
            // 2.重新组建费率数据
            this.rateAllData.push(...res.data.rate);
            this.rateAllData.push(...res.data.rateAudit);
            this.copyReward();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
          this.$router.go(-1);
        });
    },

    // 眼睛单击事件
    onEyeClick() {
      if (this.imgEyePath === 'hide_money') {
        this.agentDetail.reward = this.realRewardData;
        this.imgEyePath = 'show_money';
      } else if (this.imgEyePath === 'show_money') {
        this.agentDetail.reward = this.starRewardData;
        this.imgEyePath = 'hide_money';
      }
    },
    // 动态设置费率样式
    setRateClass(name, data) {
      let rateClass = 'center';
      if (data.indexOf('\n') > -1) {
        rateClass = 'start';
      } else {
        const len = name.length;
        switch (document.body.clientWidth) {
          case 320:
            rateClass = len > 6 ? 'start' : 'center';
            break;
          case 360:
            rateClass = len > 7 ? 'start' : 'center';
            break;
          case 375:
            rateClass = len > 8 ? 'start' : 'center';
            break;
          case 411:
          case 414:
            rateClass = len > 9 ? 'start' : 'center';
            break;
          case 480:
            rateClass = len > 10 ? 'start' : 'center';
            break;
          default:
            rateClass = 'center';
            break;
        }
      }
      return rateClass;
    },
    // copy业绩数据并加星号
    copyReward() {
      this.realRewardData = JSON.parse(JSON.stringify(this.agentDetail.reward));
      this.starRewardData = JSON.parse(JSON.stringify(this.realRewardData));
      this.starRewardData.forEach(item => (item.date = '****'));
      this.agentDetail.reward = this.starRewardData;
    },
    // 填充假数据
    fillFalseData() {
      this.agentDetail = {
        logoUrl: '',
        name: '测试01',
        level: '一级',
        mobile: '123456788',
        agentCount: '1000',
        userCount: '500',
        rate: [
          { name: '字符字符字符01', value: '100.00' },
          { name: '字符字符字符02', value: '200.00' },
          { name: '字符字符字符03', value: '300.00' },
        ],
        reward: [
          { date: '100.00', name: '字符字符字符01' },
          { date: '200.00', name: '字符字符字符02' },
          { date: '300.00', name: '字符字符字符03' },
          { date: '400.00', name: '字符字符字符04' },
        ],
      };
      this.copyReward();
    },
    // 多行费率样式
    multRateClass(value) {
      return { mult: String(value).indexOf('\n') > -1 };
    },
    // 格式化费率名称
    formatRateName(name) {
      return name.replace(/费率/g, '');
    },
    // 格式化费率值
    formatRateValue(value) {
      let tmp = value.replace(/\n/g, ',<br>');
      tmp = tmp.replace(/＋/g, '+').replace(/％/g, '%');
      const tmpArr = tmp.split(',');
      const tmpNewArr = [];
      tmpArr.forEach(str => {
        if (str.indexOf('+') > -1 && str.indexOf('%') === -1 && str.indexOf('0+') === -1) {
          tmpNewArr.push(str.replace(/[+]/g, '%+'));
        } else {
          tmpNewArr.push(str);
        }
      });
      return tmpNewArr.join('，');
    },
    // 返回商户姓名的样式名称
    getAgentNameClass() {
      return PUBLIC_SYSTEM_FLAG === 'android' ? 'android' : 'ios';
    },
    // 用户手机号点击事件
    onUserMobileClick() {
      this.userMobileShowStar = !this.userMobileShowStar;
    },
    // 返回手机号的显示格式
    getUserDetailMoblie(val) {
      return this.userMobileShowStar ? `${String(val).substr(0, 3)}****${String(val).substr(-4)}` : val;
    },
    // 费率折叠事件
    onAuditLinkClick(busChannelId) {
      Indicator.open();
      const productAgentId = this.$route.query.productAgentId;
      AuditSysRateFailNoShow({ busChannelId, productAgentId })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => CusToast('已确认您已知晓'));
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
  filters: {
    mobile(val) {
      if (!val) return val;
      return `${String(val).substr(0, 3)}****${String(val).substr(-4)}`;
    },
  },
};
</script>
